import { searchOptsFromQueryParams } from '../searchResults/helpers';
import { pathForQueryParams } from '../filter/helpers';
import React from 'react';
import Spinner from 'react-spinkit';
import { connect } from 'react-redux';
import { fetchCategory, clearCategory } from './actions';
import { track } from 'shared/models/analytic';
import { isEqual as sameAddress } from 'shared/models/address';
import { Link } from 'react-router-dom';
import Breadcrumbs from 'scy/Breadcrumbs';
import HeadTags from './head';
import CategoryHeaderImage from './headerImage';
import CategoryEmptyList from './emptyList';
import CategoryProductsList from './productsList';
import Filters from '../filter';
import AsyncLeadCaptureModal from 'components/leadCaptureModal/async';
import styles from './styles.mod.scss';
import { MainPlusAsideContainer } from 'scy/layouts';
import Card from 'scy/Card';
import { flex, centerItems, centerContent } from 'scy/flex.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import { pageContainer } from 'scy/utils.mod.scss';
import { Body } from 'scy/text';

class Category extends React.Component {
  componentDidMount() {
    const categoryUrlName = this.props.match.params.category;
    const queryParams = this.props.location.search;
    const category = this.props.category || {};
    if (categoryUrlName !== category.url_name) {
      this.loadCategory(categoryUrlName, queryParams);
    }
  }

  componentDidUpdate(prevProps) {
    const addressHasChanged = !sameAddress(
      prevProps.address,
      this.props.address
    );
    const routeHasChanged = this.props.location !== prevProps.location;
    const prevUser = prevProps.user || {};
    const nextUser = this.props.user || {};
    const userHasChanged = prevUser.objectId !== nextUser.objectId;
    if (addressHasChanged || routeHasChanged || userHasChanged) {
      this.loadCategory(
        this.props.match.params.category,
        this.props.location.search
      );
    }
  }

  componentWillUnmount() {
    this.props.clearCategory();
  }

  loadCategory(categoryUrlName, queryParams) {
    return this.props.fetchCategory(categoryUrlName, queryParams).then(() => {
      this.track(this.props.category, this.props.products);
      return null;
    });
  }

  track(category, products) {
    if (!category || !products) return;
    track('Product List Viewed', {
      list_id: category.tag,
      category: category.name,
      products: products.map(item => ({ product_id: item.sku_id }))
    });
  }

  render() {
    const {
      loadingCategory,
      loadingProducts,
      products,
      count,
      facets,
      location
    } = this.props;
    const category = this.props.category || {};
    const {
      seo_title,
      seo_description,
      name,
      description,
      url_name,
      featuredBanner
    } = category;
    const parentCategories = this.props.parentCategories || [];

    const { hitsPerPage, page } = searchOptsFromQueryParams(location.search);
    const offset = hitsPerPage * page;

    return (
      <div className={pageContainer}>
        <HeadTags
          title={seo_title || name}
          description={seo_description || description}
          slug={url_name}
        />
        <Header
          featuredBanner={featuredBanner}
          loadingCategory={loadingCategory}
          category={category}
          parentCategories={parentCategories}
        />

        {loadingCategory ? (
          <Loading />
        ) : (
          <MainPlusAsideContainer
            className={margin.tablet_top_md}
            renderAside={() => <Filters facets={facets} location={location} />}
            renderMain={() =>
              !loadingProducts && !products.length ? (
                <CategoryEmptyList />
              ) : (
                <>
                  <Card className={styles.productsCard}>
                    <CategoryProductsList
                      loading={loadingProducts}
                      products={products}
                      itemCount={count}
                      offset={offset}
                      pageSize={hitsPerPage}
                      pathForOffset={offset =>
                        pathForQueryParams(location, { skip: offset })
                      }
                    />
                  </Card>

                  {!!category.html && (
                    <Card paddingClass={padding.sm}>
                      <Body
                        tag="div"
                        dangerouslySetInnerHTML={{ __html: category.html }}
                      />
                    </Card>
                  )}
                </>
              )
            }
          />
        )}

        <AsyncLeadCaptureModal />
      </div>
    );
  }
}

function Header({
  featuredBanner,
  loadingCategory,
  category,
  parentCategories
}) {
  return (
    <div className={styles.headerContainer}>
      {featuredBanner ? (
        <div>
          <Link to={featuredBanner.link}>
            <img src={featuredBanner.image} width="100%" />
          </Link>
        </div>
      ) : (
        <CategoryHeaderImage loading={loadingCategory} category={category} />
      )}

      {loadingCategory ? null : (
        <Breadcrumbs
          parentCategories={parentCategories}
          className={styles.breadcrumbs}
        />
      )}
    </div>
  );
}

function Loading() {
  return (
    <div
      className={`${flex} ${centerItems} ${centerContent} ${padding.top_xl} ${
        margin.top_xl
      } ${padding.bottom_xl} ${margin.bottom_xl}`}
    >
      <Spinner spinnerName="three-bounce" />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    address: state.address,
    user: state.login.user,
    loadingCategory: state.category.loadingCategory,
    loadingProducts: state.category.loadingProducts,
    category: state.category.category,
    parentCategories: state.category.parentCategories,
    products: state.category.products,
    count: state.category.count,
    facets: state.category.facets,
    pageSize: state.category.pageSize,
    skip: state.category.skip
  };
}

export default connect(
  mapStateToProps,
  { fetchCategory, clearCategory }
)(Category);
